import { render, staticRenderFns } from "./PageControlDetalles.vue?vue&type=template&id=97f34bf0&"
import script from "./PageControlDetalles.vue?vue&type=script&lang=js&"
export * from "./PageControlDetalles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports